import MoviePoster from '../../../images/movies-poster.jpg';

export const allMovies = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The Exorcist', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'Spiral: From the Book of Saw', image: `${MoviePoster}`, year: '2022', liked: false,
  },
];

export const slasherIndieMovies = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The Exorcist', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'Spiral: From the Book of Saw', image: `${MoviePoster}`, year: '2022', liked: false,
  },
];

export const favoritesMovies = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The Exorcist', image: `${MoviePoster}`, year: '2022', liked: true,
  },
];

export const watchMovieList = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The Exorcist', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'Spiral: From the Book of Saw', image: `${MoviePoster}`, year: '2022', liked: false,
  },
];

export const watchedMovieList = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The Exorcist', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'Spiral: From the Book of Saw', image: `${MoviePoster}`, year: '2022', liked: false,
  },
];

export const buyMovieList = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
  {
    id: 3, name: 'Ghost Lab', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 4, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 5, name: 'The Exorcist', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 6, name: 'Spiral: From the Book of Saw', image: `${MoviePoster}`, year: '2022', liked: false,
  },
];

export const myMovies = [
  {
    id: 1, name: 'Dreamcatcher: Get ready for a killer night out', image: `${MoviePoster}`, year: '2022', liked: true,
  },
  {
    id: 2, name: 'The Djinn', image: `${MoviePoster}`, year: '2022', liked: false,
  },
];
